'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../../../../customer/actions');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _DispatchWarning = require('../DispatchWarning');

var _DispatchWarning2 = _interopRequireDefault(_DispatchWarning);

var _OrderConfirmation = require('./OrderConfirmation');

var _OrderConfirmation2 = _interopRequireDefault(_OrderConfirmation);

var _Opener = require('../Opener');

var _Opener2 = _interopRequireDefault(_Opener);

var _ContactForm = require('./ContactForm');

var _ContactForm2 = _interopRequireDefault(_ContactForm);

var _DeliveryAddress = require('./DeliveryAddress');

var _DeliveryAddress2 = _interopRequireDefault(_DeliveryAddress);

var _ModalDialog = require('../ModalDialog');

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _UserContactsBase2 = require('./UserContactsBase');

var _UserContactsBase3 = _interopRequireDefault(_UserContactsBase2);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _AddressForm = require('./AddressForm');

var _AddressForm2 = _interopRequireDefault(_AddressForm);

var _Note = require('./Note');

var _Note2 = _interopRequireDefault(_Note);

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _storageProvider = require('../../../../storageProvider');

var _storageProvider2 = _interopRequireDefault(_storageProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

function mapStateToProps(state) {
    return {
        contact: state.customer.contact,
        contactErrors: state.customer.contactErrors,
        editingDeliveryAddress: state.customer.editingDeliveryAddress,
        selectedDeliveryId: state.cart.deliveryTypeId
    };
}

var mapDispatchToProps = {
    changeContact: _actions2.default.changeContact,
    saveContact: _actions2.default.saveContact,
    editAddress: _actions2.default.editAddress,
    saveAddress: _actions2.default.saveAddress,
    discardAddress: _actions2.default.discardAddress
};

var RegisteredUserContacts = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_UserContactsBase) {
    (0, _inherits3.default)(RegisteredUserContacts, _UserContactsBase);

    function RegisteredUserContacts(props) {
        (0, _classCallCheck3.default)(this, RegisteredUserContacts);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RegisteredUserContacts.__proto__ || (0, _getPrototypeOf2.default)(RegisteredUserContacts)).call(this, props, false));

        _this.openContactModal = function () {
            var emptyModel = {
                email: '',
                phoneNumber: '',
                firstName: '',
                lastName: '',
                street: '',
                postCode: '',
                city: '',
                countryId: null,
                companyName: '',
                companyNumber: '',
                vatNumber: ''
            };
            _this.setState((0, _extends3.default)({}, _this.state, {
                showContactModal: true,
                contact: (0, _extends3.default)({}, emptyModel, (0, _pick2.default)(_this.props.contact, (0, _keys2.default)(emptyModel)))
            }));
        };

        _this.onSubmitContactModal = function () {
            _this.props.saveContact().then(function () {
                if (!_this.props.contactErrors.hasErrors) {
                    _this.setState((0, _extends3.default)({}, _this.state, { showContactModal: false, contact: null }));
                }
            });
        };

        _this.onCloseContactModal = function () {
            _this.props.changeContact(_this.state.contact);
            _this.setState((0, _extends3.default)({}, _this.state, { showContactModal: false, contact: null }));
        };

        _this.editAddress = function (address) {
            _this.setState((0, _extends3.default)({}, _this.state, { editingAddress: (0, _extends3.default)({}, address) }));
            return false;
        };

        _this.saveAddress = function (address) {
            _this.discardAddress();
            _this.props.saveAddress(address);
        };

        _this.discardAddress = function () {
            _this.setState((0, _extends3.default)({}, _this.state, { editingAddress: null }));
        };

        _this.state = {
            showContactModal: false,
            editingAddress: null,
            allowedCountries: []
        };
        return _this;
    }

    (0, _createClass3.default)(RegisteredUserContacts, [{
        key: 'canContinue',
        value: function canContinue() {
            var contact = this.props.contact;
            var allowedCountries = this.state.allowedCountries;


            var deliverId = contact.countryId;
            if (contact.useCustomDeliveryAddress && contact.deliveryAddressId !== undefined) {
                var deliveryAddresses = this.filterDeliveryAddresses(contact, allowedCountries);
                var delAdd = deliveryAddresses.find(function (d) {
                    return d.id === contact.deliveryAddressId;
                });
                if (delAdd) deliverId = delAdd.countryId;
            }

            return allowedCountries.indexOf(parseInt(deliverId)) > -1;
        }
    }, {
        key: 'cartNote',
        value: function cartNote() {
            if (_utils2.default.skEnvironment()) {
                return _react2.default.createElement(_Note2.default, null);
            }
            return null;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var selectedDeliveryId = this.props.selectedDeliveryId;


            var key = 'countries_delivery_type_id_' + selectedDeliveryId;
            var cachedValue = _storageProvider2.default.getValue(key);
            if (cachedValue) {
                this.setCountries(cachedValue);
                return;
            }

            (0, _ajax2.default)({ url: '/odata/CountryLookup?deliveryCountries=true&selectedDeliveryId=' + selectedDeliveryId }).done(function (data) {
                if (_this2.state.allowedCountries.length === 0) {
                    // set to state
                    _this2.setCountries(data.value);
                    // set to cache
                    _storageProvider2.default.setValue(key, data.value);
                }
            });
        }
    }, {
        key: 'setCountries',
        value: function setCountries(countriesPure) {
            var allowedCountries = countriesPure.map(function (x) {
                return x.id;
            });
            this.setState((0, _extends3.default)({}, this.state, { allowedCountries: [].concat((0, _toConsumableArray3.default)(allowedCountries)) }));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                contact = _props.contact,
                contactErrors = _props.contactErrors;
            var vatNumber = contact.vatNumber,
                companyNumber = contact.companyNumber,
                companyName = contact.companyName,
                defaultCountryId = contact.defaultCountryId;

            var companyFilled = vatNumber || companyNumber || companyName;
            var _state = this.state,
                editingAddress = _state.editingAddress,
                allowedCountries = _state.allowedCountries;

            var deliveryAddresses = this.filterDeliveryAddresses(contact, allowedCountries);

            return _react2.default.createElement(
                'div',
                { className: 'cart-step3__form' },
                _react2.default.createElement(
                    'h3',
                    { className: 'cart__section-title' },
                    Resx.App.DeliveryAndBillingInfo
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cart__form without_registration' },
                    _react2.default.createElement(_ContactForm2.default, { readonly: true, contact: contact, errors: contactErrors,
                        selectedDeliveryId: this.props.selectedDeliveryId }),
                    !!companyFilled && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'label',
                            { className: 'opener__trigger mb-2' },
                            _react2.default.createElement('i', { className: 'icon--tie' }),
                            Resx.App.IAmCompany
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            this.companyInfo(true)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'text-center space-t-20 space-b-20' },
                        _react2.default.createElement(
                            'a',
                            { className: 'btn btn--sm btn--blue', onClick: this.openContactModal },
                            _react2.default.createElement('i', { className: 'icon--pen' }),
                            ' ',
                            Resx.App.ChangeContactInfo
                        )
                    ),
                    _react2.default.createElement('hr', { className: 'hr--no-mr' }),
                    _react2.default.createElement(
                        _Opener2.default,
                        { icon: 'icon--home', title: Resx.App.DifferentDeliveryAddress,
                            open: contact.useCustomDeliveryAddress,
                            onChange: function onChange(e) {
                                return _this3.changeState('useCustomDeliveryAddress', e.target.checked);
                            } },
                        _react2.default.createElement(
                            'div',
                            { className: 'delivery__boxes' },
                            (deliveryAddresses || []).map(function (address) {
                                return _react2.default.createElement(_DeliveryAddress2.default, (0, _extends3.default)({}, address, { key: address.id,
                                    selected: address.id === contact.deliveryAddressId,
                                    readOnly: allowedCountries.indexOf(address.countryId) < 0,
                                    onEditClick: function onEditClick() {
                                        return _this3.editAddress(address);
                                    },
                                    onChange: function onChange(e) {
                                        return _this3.changeState('deliveryAddressId', address.id);
                                    } }));
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'text-center' },
                            _react2.default.createElement(
                                'a',
                                { className: 'btn btn--sm', href: '#', onClick: function onClick() {
                                        return _this3.editAddress({});
                                    } },
                                _react2.default.createElement('i', {
                                    className: 'icon--plus' }),
                                ' ',
                                Resx.App.AddNewAddress
                            )
                        )
                    ),
                    _react2.default.createElement('hr', { className: 'hr--no-mr' }),
                    this.cartNote(),
                    _react2.default.createElement('hr', { className: 'hr--no-mr-top' }),
                    _react2.default.createElement(_DispatchWarning2.default, null),
                    _react2.default.createElement(_OrderConfirmation2.default, { canContinue: function canContinue() {
                            return _this3.canContinue();
                        } })
                ),
                !!editingAddress && _react2.default.createElement(
                    _ModalDialog2.default,
                    { show: !!editingAddress, onClose: this.discardAddress, hideSubmitButton: true },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__form', style: { maxWidth: 600 } },
                        _react2.default.createElement(_AddressForm2.default, { value: editingAddress || { countryId: defaultCountryId },
                            onChange: this.saveAddress, defaultCountryId: defaultCountryId })
                    )
                ),
                _react2.default.createElement(
                    _ModalDialog2.default,
                    { show: this.state.showContactModal,
                        onSubmit: this.onSubmitContactModal,
                        onClose: this.onCloseContactModal,
                        title: Resx.App.DeliveryAndBillingInfo },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__form', style: { maxWidth: 600, paddingBottom: 30 } },
                        _react2.default.createElement(_ContactForm2.default, { contact: contact || {}, errors: contactErrors, mode: _ContactForm.FormMode.registered,
                            onChange: this.props.changeContact, isInModal: true,
                            selectedDeliveryId: this.props.selectedDeliveryId }),
                        _react2.default.createElement('hr', { className: 'hr--no-mr-bottom' }),
                        this.companyInfo()
                    )
                )
            );
        }
    }, {
        key: 'filterDeliveryAddresses',
        value: function filterDeliveryAddresses(contact, allowedCountries) {
            return contact.deliveryAddresses.filter(function (da) {
                return allowedCountries.indexOf(da.countryId) >= 0;
            });
        }
    }]);
    return RegisteredUserContacts;
}(_UserContactsBase3.default), _class2.propTypes = {
    contact: _propTypes2.default.object,
    contactErrors: _propTypes2.default.object,
    changeContact: _propTypes2.default.func,
    selectedDeliveryId: _propTypes2.default.number
}, _temp)) || _class);
exports.default = RegisteredUserContacts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/RegisteredUserContacts.js
// module id = 1035
// module chunks = 0